export type ExternalLinkRelPolicy = "follow" | "nofollow" | "sponsored" | "ugc"

type ExternalLinkRelOptions = {
  doFollow?: boolean
  relPolicy?: ExternalLinkRelPolicy
}

type SafeExternalLinkRelOptions = ExternalLinkRelOptions & {
  rel?: string
  target?: string
}

export function getExternalLinkRel({
  doFollow = false,
  relPolicy,
}: ExternalLinkRelOptions): string {
  if (relPolicy === "follow") return "noopener"
  if (relPolicy === "sponsored") return "noopener sponsored nofollow"
  if (relPolicy === "ugc") return "noopener ugc nofollow"
  if (relPolicy === "nofollow") return "noopener nofollow"

  return doFollow ? "noopener" : "noopener nofollow"
}

export function getSafeExternalLinkRel({
  rel,
  target,
  ...options
}: SafeExternalLinkRelOptions): string {
  const tokens = new Set((rel ?? getExternalLinkRel(options)).split(/\s+/).filter(Boolean))

  if (target === "_blank") {
    tokens.add("noopener")
  }

  return [...tokens].join(" ")
}
